goog.provide("shadow.js.shim.module$src$svg$wpp$filter$tune_svg$default");
shadow.js.shim.module$src$svg$wpp$filter$tune_svg$default = shadow.js.shim.module$src$svg$wpp$filter$tune_svg.default;
